import {
  EffectFade,
  Autoplay,
  Navigation,
  Pagination,
  A11y,
  Grid,
  Mousewheel,
  EffectCoverflow,
} from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

export function useSwiper() {
  return {
    modules: [
      EffectFade,
      Autoplay,
      Navigation,
      Pagination,
      A11y,
      Grid,
      Mousewheel,
      EffectCoverflow,
    ],
    Swiper,
    SwiperSlide,
  }
}
